/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import { combineEpics } from 'redux-observable';
import { combineReducers } from 'redux';

import companiesRducer from "./company/companies.slice";
import companiesEpics from './company/companies.epics';

import groupsReducer from "./company/groups.slice";
import groupsEpics from "./company/groups.epics";

import usersReducer from "./company/users.slice";
import usersEpics from "./company/users.epics";

import assetGroupsReducer from "./company/assetGroups.slice";
import assetGroupsEpics from './company/assetGroups.epics';

import availableAssetFiltersReducer from "./company/availableAssetFilters.slice";
import availableAssetFiltersEpics from "./company/availableAssetFilters.epics";

import selectedAssetFiltersReducer from "./company/selectedAssetFilters.slice";
import selectedAssetFiltersEpics from "./company/selectedAssetFilters.epics";

import cvesReducer from "./company/cves.slice";
import cvesEpics from "./company/cves.epics";

import cveBrowserEpics from "./company/cveBrowser.epics";

const epics = [
   ...companiesEpics,
   ...groupsEpics,
   ...usersEpics,
   ...assetGroupsEpics,
   ...availableAssetFiltersEpics,
   ...selectedAssetFiltersEpics,
   ...cvesEpics,
   ...cveBrowserEpics,
] as any

export const rootReducer = combineReducers({
   companies: companiesRducer,
   groups: groupsReducer,
   users: usersReducer,
   assetGroups: assetGroupsReducer,
   availableAssetFilters: availableAssetFiltersReducer,
   selectedAssetFilters: selectedAssetFiltersReducer,
   cves: cvesReducer
});

export const rootEpic = combineEpics(...epics);
